import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { WebSocketProvider } from './components/WebSocketProvider';
import { InstallPrompt } from './components/InstallPrompt';
import { OfflineIndicator } from './components/OfflineIndicator';
import { useOfflineSync } from './hooks/useOfflineSync';
import { LoginPage } from './pages/auth/LoginPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { ClientesPage } from './pages/clientes/ClientesPage';
import { IndustriasPage } from './pages/industrias/IndustriasPage';
import { ProdutosPage } from './pages/produtos/ProdutosPage';
import { PedidosPage } from './pages/pedidos/PedidosPage';
import { NovoPedidoPage } from './pages/pedidos/NovoPedidoPage';
import { EditarPedidoPage } from './pages/pedidos/EditarPedidoPage';
import { UsuariosPage } from './pages/admin/UsuariosPage';
import { PerfilPage } from './pages/perfil/PerfilPage';
import { AdminRoute } from './components/auth/AdminRoute';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  // Inicializa sincronização offline
  useOfflineSync()

  return (
    <>
      <WebSocketProvider />

      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>

            }
          />
          <Route
            path="/clientes"
            element={
              <ProtectedRoute>
                <ClientesPage />
              </ProtectedRoute>

            }
          />
          <Route
            path="/industrias"
            element={
              <ProtectedRoute>
                <IndustriasPage />
              </ProtectedRoute>


            }
          />
          <Route
            path="/produtos"
            element={
              <ProtectedRoute>
                <ProdutosPage />
              </ProtectedRoute>


            }
          />
          <Route
            path="/pedidos"
            element={
              <ProtectedRoute>
                <PedidosPage />
              </ProtectedRoute>


            }
          />
          <Route
            path="/pedidos/novo"
            element={
              <ProtectedRoute>
                <NovoPedidoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pedidos/editar/:id"
            element={
              <ProtectedRoute>
                <EditarPedidoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <AdminRoute>
                <UsuariosPage />
              </AdminRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <ProtectedRoute>
                <PerfilPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter >

      <Toaster position="top-right" richColors />
      <OfflineIndicator />
      <InstallPrompt />
    </>
  )
}

export default App

